<template>
    <hts-drawer
        v-model="visible"
        :rules="rulesAddNodeType"
        :submit="handleSubmit"
        :title="$t('labels.nodeTypeModule.edit')"
        @close="visible = false">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-select
                ref="selectTypeName"
                v-model="dataEdit.name"
                :items="nodeTypeNames"
                :filterable="true"
                :clearable="true"
                :label="$t('labels.nodeTypeModule.name')"
                required
                name="nodeTypeModule.name"
                prop="nodeTypeModule.name"
                key-id="value"
                key-label="value"
                creatable
                @create-new="handleCreateNewNodeType" />

            <hts-form-input
                v-model="dataEdit.description"
                :label="$t('labels.description')"
                :color="props.color"
                name="description"
                prop="description" />

            <hts-form-select
                v-if="dataEdit?.businessSelected && dataEdit.businesses"
                v-model="dataEdit.businesses"
                :query="findBusinesses"
                :filterable="true"
                :clearable="true"
                :label="$t('labels.business')"
                required
                multiple
                name="business"
                prop="business"
                key-id="_id"
                key-label="name"
                key-tooltip="tasksName"
                :selected-multiple="dataEdit?.businessSelected || []" />
        </hts-card>

        <hts-modal v-model="addNewNodeTypeName">
            <template #custom>
                <hts-card
                    :title="$t('labels.nodeTypeName')"
                    class="mt-5">
                    <hts-form-input v-model="newNodeTypeName" />
                </hts-card>
                <div class="flex mt-5 justify-end">
                    <hts-form-button
                        icon-name="hi-check-icon"
                        icon-position="right"
                        color="primary"
                        type="submit"
                        :loading="false"
                        :disabled="!newNodeTypeName"
                        @click="createNewNodeType(newNodeTypeName)">
                        {{ $t('labels.save') }}
                    </hts-form-button>

                    <hts-form-button
                        class="pl-2"
                        icon-name="hi-x-mark-icon"
                        icon-position="right"
                        color="error"
                        @click="addNewNodeTypeName = false">
                        {{ $t('labels.cancel') }}
                    </hts-form-button>
                </div>
            </template>
        </hts-modal>
    </hts-drawer>
</template>
<script setup lang="ts">
import { rulesAddNodeType, INodeType } from '../imports/model'
import { initNodeTypeNames } from '../imports/utils'
import { $urlSystem } from '#imports'
const nodeTypeNames = ref(initNodeTypeNames())
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  }
})

const dataEdit = ref<INodeType | undefined>({
  _id: '',
  code: '',
  name: '',
  businesses: [],
  businessSelected: []
})

const visible = ref(false)
const selectTypeName = ref()
const addNewNodeTypeName = ref(false)
const newNodeTypeName = ref('')

const open = (idNodeType: string) => {
  visible.value = true
  if (!idNodeType) {
    dataEdit.value = undefined
    return
  }
  const api = $urlSystem.node.type.getDetail
  $api(api, { uriParams: { ID: idNodeType } })
    .then((data) => {
      const resData: any = data?.data?.value
      if (resData.success) {
        resData.data.businessSelected = [...resData.data.businesses]
        resData.data.businesses =
          resData.data.businesses.map((business: any) => {
            return business._id
          }) || []
        dataEdit.value = resData.data
        createNewNodeType(resData.data.name, true)
      }
    })
    .catch((e: any) => {
      dataEdit.value = undefined
    })
}
defineExpose({
  open
})

const handleSubmit = () => {
  const api = $urlSystem.node.type.edit
  if (!dataEdit.value || !dataEdit.value._id) {
    return
  }
  $api(api, { uriParams: { ID: dataEdit.value._id }, body: dataEdit.value }).then((data) => {
    const resData: any = data?.data?.value

    if (resData.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.editSuccess'))
      visible.value = false
    }
  })
}

const findBusinesses = async (s: string) => {
  const api = $urlSystem.business.select
  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data.value
  if (resData.success) {
    return resData.data
  }
  return null
}

const emits = defineEmits(['close', 'refreshTables', 'newBusiness', 'update:show'])

const closeOverSide = () => {
  emits('close')
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const handleCreateNewNodeType = () => {
  newNodeTypeName.value = ''
  addNewNodeTypeName.value = true
  if (selectTypeName.value) {
    selectTypeName.value.hide()
  }
}

const createNewNodeType = (newName?: string, deleteOldItem?: Boolean) => {
  if (!dataEdit?.value) {
    return
  }

  if (!newName) {
    return
  }

  if (deleteOldItem) {
    nodeTypeNames.value = initNodeTypeNames()
  }

  const checkName = nodeTypeNames.value.map((nodeTypeName) => {
    if (nodeTypeName.value === newName) {
      return true
    }
    return false
  })

  if (checkName.includes(true)) {
    dataEdit.value.name = newName
    addNewNodeTypeName.value = false
    return
  }

  nodeTypeNames.value.push({
    value: newName
  })
  dataEdit.value.name = newName
  addNewNodeTypeName.value = false
  selectTypeName.value.hide()
}
</script>
